import React, { Component } from "react";
import "./AlertCss.css";


export class AlertMessageError extends Component {
  constructor(props) {
    super(props);
  }
  render() {

    return (
      <div className="">
        <div className="alert-message-div animate">
          <div
            className="alert alert-styles"
            show={this.props.show}
            color="white"
          >
            <p className="text-right m-0">
              <i
                class="fa fa-times-circle close-icon alert-error-heading-txt"
                onClick={this.props.onClose}
              ></i>
            </p>
            <div className="d-flex">
              <img
                id="imgSuccess"
                src="../img/warning.png"
                aria-hidden="true"
                className="alert-img-width"
              />
              <p className="font-size-13 m-b">
                <span className="font-size-14 alert-error-heading-txt">Error!</span>
                <br />
                {this.props.message}
                <br/>
                {this.props.subMessage ? <span>{this.props.subMessage}</span>:""}
               

              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AlertMessageError;
